import "./cleaner.css";
import { useNavigate, useParams } from "react-router";
import { Loading } from "../components/ui";
import { isClockToken } from "../lib/scanner";
import { useSession } from "../session";
import { InstallHelp } from "./help";

/**
 * /c/:token — someone scanned a site sticker with the phone's own Camera app.
 * This route is outside the sign-in gate. On iPhone the Camera app opens Safari, where
 * the cleaner usually isn't signed in (the Home Screen app has its own sign-in), so we
 * point them back to the app. If they are signed in here (e.g. Android's installed app
 * opens the link), we can clock with the code directly.
 */
export function ScannedLinkPage() {
  const { token } = useParams();
  const { me, loading } = useSession();
  const navigate = useNavigate();

  if (!isClockToken(token)) {
    return (
      <div className="page-narrow cl-page">
        <div className="card stack">
          <h1>That's not one of our site codes</h1>
          <p>This link doesn't look like one of our site stickers.</p>
          <a className="btn block" href="/">
            Open the app
          </a>
        </div>
      </div>
    );
  }

  if (loading && !me) return <Loading />;

  if (me) {
    const clockedIn = !!me.openVisit;
    return (
      <div className="page-narrow cl-page">
        <div className="card stack">
          <h1>Site code scanned</h1>
          <p>
            {clockedIn ? (
              <>
                You're clocked in at <strong>{me.openVisit?.siteName}</strong>.
              </>
            ) : (
              "You're not clocked in yet."
            )}
          </p>
          <button
            className="btn primary huge"
            onClick={() => navigate("/", { state: { scannedToken: token } })}
          >
            {clockedIn ? "Clock out with this code" : "Clock in with this code"}
          </button>
          <button className="btn ghost block" onClick={() => navigate("/")}>
            Go to the app
          </button>
          <p className="small muted">
            Tip: it's quicker to open the NKLEAN Hub app and tap {clockedIn ? "Clock out" : "Clock in"} — it
            scans the code for you.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-narrow cl-page">
      <div className="card stack">
        <div className="cl-icon" aria-hidden="true">
          📱
        </div>
        <h1>Open the NKLEAN Hub app</h1>
        <p className="cl-lead">
          Open the <strong>NKLEAN Hub</strong> app from your home screen and tap <strong>Clock in</strong>.
          The app scans the code for you.
        </p>
        <p className="muted">
          Your phone's camera opened this page in the web browser, where you aren't signed in, so it can't
          clock you in from here.
        </p>
      </div>
      <div className="card stack">
        <h2>Don't have the app yet?</h2>
        <InstallHelp />
      </div>
    </div>
  );
}
